import React, { useCallback } from 'react';
import { VisibilityOffFill, Visibility } from '@crabs-ai/web-icons';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { hideTrack, unhideTrack } from '../../state/actions/hide-track';
import { TrackType } from '../../state/types';
import { useWriteContext } from '../../utils/use-context';

export const TimelineHideTrack = ({ track }: { track: TrackType }) => {
  const { setState } = useWriteContext();
  const t = useTranslations();

  const toggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      setState({
        update: (state) =>
          track.hidden
            ? unhideTrack(state, track.id)
            : hideTrack(state, track.id),
        commitToUndoStack: false,
      });
    },
    [track.hidden, setState, track.id],
  );

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <ToolButton
      size="sm"
      state={track.hidden ? 'selected' : 'default'}
      onClick={toggle}
      onPointerDown={onPointerDown}
      isShowTooltip
      tooltipNode={
        track.hidden
          ? t('Editor.timeline.show-track')
          : t('Editor.timeline.hide-track')
      }
      tooltipPosition="top"
    >
      {track.hidden ? <VisibilityOffFill /> : <Visibility />}
    </ToolButton>
  );
};
